// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* One column on phones, name/surname and tax code/email in pairs from tablet width up */
.resident-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  padding-bottom: var(--ion-safe-area-bottom);
}
@media (min-width: 576px) {
  .resident-form {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.resident-form ion-input {
  --border-radius: 10px;
  --highlight-color-focused: var(--ion-color-primary);
  min-height: 56px;
}
.resident-form__full {
  grid-column: 1/-1;
}
.resident-form {
  /* Only the typed value is upper case (fiscal codes are), not the field label */
}
.resident-form__tax-code ::ng-deep input {
  text-transform: uppercase;
}
.resident-form {
  /* Already set and no longer editable: readable instead of Ionic's washed-out disabled look
   * (.input-disabled { opacity: 0.38 }), on a tinted background and with a lock */
}
.resident-form ion-input.resident-form__locked,
.resident-form ion-input.resident-form__locked.input-disabled {
  --background: rgba(var(--ion-color-medium-rgb), 0.07);
  --color: var(--ion-color-medium-shade);
  opacity: 1;
}
.resident-form ion-input.resident-form__locked ion-icon,
.resident-form ion-input.resident-form__locked.input-disabled ion-icon {
  font-size: 18px;
  color: var(--ion-color-medium);
}`, "",{"version":3,"sources":["webpack://./src/components/form-components/form-residents/form-residents.component.scss"],"names":[],"mappings":"AAAA,wFAAA;AACA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,2CAAA;AACF;AACE;EANF;IAOI,gDAAA;EAEF;AACF;AAAE;EACE,qBAAA;EACA,mDAAA;EACA,gBAAA;AAEJ;AACE;EACE,iBAAA;AACJ;AAlBA;EAoBE,+EAAA;AACF;AAAE;EACE,yBAAA;AAEJ;AAxBA;EAyBE;kFAAA;AAGF;AADE;;EAEE,qDAAA;EACA,sCAAA;EACA,UAAA;AAGJ;AADI;;EACE,eAAA;EACA,8BAAA;AAIN","sourcesContent":["/* One column on phones, name/surname and tax code/email in pairs from tablet width up */\n.resident-form {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 16px;\n  padding-bottom: var(--ion-safe-area-bottom);\n\n  @media (min-width: 576px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  ion-input {\n    --border-radius: 10px;\n    --highlight-color-focused: var(--ion-color-primary);\n    min-height: 56px;\n  }\n\n  &__full {\n    grid-column: 1 / -1;\n  }\n\n  /* Only the typed value is upper case (fiscal codes are), not the field label */\n  &__tax-code ::ng-deep input {\n    text-transform: uppercase;\n  }\n\n  /* Already set and no longer editable: readable instead of Ionic's washed-out disabled look\n   * (.input-disabled { opacity: 0.38 }), on a tinted background and with a lock */\n  ion-input.resident-form__locked,\n  ion-input.resident-form__locked.input-disabled {\n    --background: rgba(var(--ion-color-medium-rgb), 0.07);\n    --color: var(--ion-color-medium-shade);\n    opacity: 1;\n\n    ion-icon {\n      font-size: 18px;\n      color: var(--ion-color-medium);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
